import ReadingUtil from 'aegion_common_utilities/lib/ReadingsUtil';

import { selectConvertedReadings } from '../selectors/readings';
import {
	selectStaticSelectedSurvey,
	selectEditableSelectedSurvey,
	selectStaticSurveyReadings,
	selectEditableSurveyReadings,
	selectStationAlignment
} from '../selectors/stationAlignment';
import { getAlignmentSuggestions } from './util/stationAlignmentSuggestions';
import {
	computeOptionsByStationAlignmentType,
	createMergedSelectedReading,
	getComputedReadings
} from '../reducers/stationAlignment';
import { getUploadPolicySave } from '../../utils/JobUtil/JubUtil.api';
import { selectJobId } from '../selectors/job';
import {
	createFormDataForSaveGeneric,
	getSignedURL,
	pullUsingJquery,
	uploadUsingJquery
} from '../../utils/JobUtil/JobUtil.saveGpsReadings';
import { getObject } from '../../../util/persist/utils/s3.api';

const NS = 'CISV_STATION_ALIGNMENT_';

export const setSelectedDataForStationAlignment = (survey, tableType) => ({
	type: 'CISV_STATION_ALIGNMENT_SET_DAT_FILE',
	survey,
	tableType
});

export const setSelectedSurveyIsLinkedForStationAlignment = isLinked => ({
	type: 'CISV_STATION_ALIGNMENT_SET_SELECTED_SURVEY_IS_LINKED',
	isLinked,
	tableType: 'static'
});

export const selectReadingForStationAlignment = (
	tableType,
	readingIndex,
	readingObject
) => (dispatch, getState) => {
	const convertedReadings = selectConvertedReadings(getState());
	return dispatch({
		type: 'CISV_STATION_ALIGNMENT_SET_READING_SELECTED',
		tableType,
		readingIndex,
		readingObject,
		convertedReadings
	});
};

export const resetSurveyAlignment = data => {
	return {
		type: 'CISV_STATION_ALIGNMENT_RESET',
		data
	};
};

export const setEditableSurvey = survey => {
	return {
		type: 'CISV_STATION_ALIGNMENT_SET_EDITABLE_SURVEY',
		survey
	};
};

export const SET_MAP_SELECTED = `${NS}SET_MAP_SELECTED`;
export const setMapSelected = (tableType, selected) => {
	return {
		type: SET_MAP_SELECTED,
		payload: { tableType, selected }
	};
};

function getFileName(filename) {
	const [_, newFileName] = /([^\/]*)_gpsReadings.json$/.exec(filename);
	return newFileName;
}

function getFile(fileName, survey) {
	const masterLSTFileName = Object.keys(survey.MasterLST).find(
		attr => fileName.toLowerCase().indexOf(attr.toLowerCase()) !== -1
	);
	return {
		...survey.MasterLST[masterLSTFileName],
		datIndex: Object.keys(survey.MasterLST).indexOf(masterLSTFileName)
	};
}

function findReading(reading, file, station) {
	return reading.datIndex === file.datIndex && reading.StationId === station;
}

export const pullLedger = () => async (dispatch, getState) => {
	const state = getState();

	const jobguuid = selectJobId(state);

	const { url } = await getSignedURL(jobguuid);

	const res = await fetch(url);

	if (res.status == 200) {
		const alignmentLedger = await res.json();
		console.log(alignmentLedger);

		const {
			optionsByStationAlignmentType,
			mergedSelectedReadings,
			optionsByStationAlignmentType: {
				editable: { readingsSelected } = {}
			} = {}
		} = alignmentLedger;

		if (readingsSelected) {
			const convertedReadings = selectConvertedReadings(state);
			const realignedComputedReadings = getComputedReadings(
				convertedReadings,
				readingsSelected
			);

			const payload = {
				optionsByStationAlignmentType,
				mergedSelectedReadings,
				realignedComputedReadings
			};

			return dispatch({
				type: 'CISV_STATION_ALIGNMENT_SET_SUGGESTIONS',
				payload
			});
		}
	}
};

export const saveLedger = () => async (dispatch, getState) => {
	const state = getState();

	const jobguid = selectJobId(state);

	const {
		realignedComputedReadings,
		...stationAlignment
	} = selectStationAlignment(state);

	const policyData = await getUploadPolicySave(
		`station-alignment-ledger.json`,
		'000000',
		jobguid,
		'dats'
	);

	const formData = createFormDataForSaveGeneric(
		policyData,
		`station-alignment-ledger.json`,
		stationAlignment
	);

	uploadUsingJquery(policyData.upload_url, formData);
};

export const getSuggestions = () => async (dispatch, getState) => {
	const { cisview } = getState();
	const suggestions = (await getAlignmentSuggestions(cisview)) || [];

	const state = getState();
	const staticSelectedSurvey = selectStaticSelectedSurvey(state);
	const editableSelectedSurvey = selectEditableSelectedSurvey(state);

	const editableReadings = selectEditableSurveyReadings(state);
	const staticReadings = selectStaticSurveyReadings(state);

	const convertedReadings = selectConvertedReadings(state);

	const {
		mergedSelectedReadings,
		newEditableReadings,
		newStaticReadings
	} = suggestions.reduce(
		(acc, suggestion) => {
			const {
				depol_file,
				onoff_file,
				depol_station,
				onoff_station
			} = suggestion;
			const deployFile = getFile(depol_file, staticSelectedSurvey);
			const onOffFile = getFile(onoff_file, editableSelectedSurvey);
			const staticReading = staticReadings.find(reading =>
				findReading(reading, deployFile, depol_station)
			);
			const editableReading = editableReadings.find(reading =>
				findReading(reading, onOffFile, onoff_station)
			);
			if (staticReadings.indexOf(staticReading) === -1) {
				console.log(staticReading);
			}
			const {
				mergedSelectedReading,
				newEditableReading
			} = createMergedSelectedReading(
				{
					...staticReading,
					readingIndex: staticReadings.indexOf(staticReading)
				},
				{
					...editableReading,
					readingIndex: editableReadings.indexOf(editableReading)
				}
			);
			const {
				newEditableReading: newStaticReading
			} = createMergedSelectedReading(
				{
					...editableReading,
					readingIndex: editableReadings.indexOf(editableReading)
				},
				{
					...staticReading,
					readingIndex: staticReadings.indexOf(staticReading)
				}
			);
			acc.mergedSelectedReadings.push(mergedSelectedReading);
			acc.newEditableReadings.push(newEditableReading);
			acc.newStaticReadings.push(newStaticReading);
			return acc;
		},
		{
			mergedSelectedReadings: [],
			newEditableReadings: [],
			newStaticReadings: []
		}
	);

	const realignedComputedReadings = getComputedReadings(
		convertedReadings,
		newEditableReadings
	);

	const optionsByStationAlignmentType = computeOptionsByStationAlignmentType(
		selectStationAlignment(getState()),
		newEditableReadings,
		newStaticReadings
	);

	const payload = {
		optionsByStationAlignmentType,
		mergedSelectedReadings,
		realignedComputedReadings
	};

	return dispatch({ type: 'CISV_STATION_ALIGNMENT_SET_SUGGESTIONS', payload });
};
